import React from 'react';
import { useLocation } from 'react-router-dom';
import { Dialog } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import BuildIcon from '@mui/icons-material/Build';

import { isEnabled, FEATURE_MAINTENANCE } from 'helpers/features';

export default function MaintenanceModal(): React.ReactElement {
    const location = useLocation();
    const showModal =
        isEnabled(FEATURE_MAINTENANCE) && location.pathname.includes('budget_');

    return (
        <Dialog fullWidth maxWidth="sm" open={showModal}>
            <DialogTitle>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: 20,
                    }}
                >
                    <BuildIcon style={{ marginRight: '0.5rem' }} />
                    <span>Maintenance en cours</span>
                </div>
            </DialogTitle>
            <DialogContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 200,
                    textAlign: 'justify',
                    fontSize: 18,
                }}
            >
                {`Veuillez nous excuser, notre module budget est actuellement en
                cours de maintenance. Nous espérons le réactiver dans moins
                d'une heure.`}
                <div style={{ marginTop: '1.5rem' }}>
                    Merci pour votre patience.
                </div>
            </DialogContent>
        </Dialog>
    );
}
